import React, { useRef } from "react";
import { useGLTF, Html } from "@react-three/drei";

export default function Tree(props) {
  const { nodes, materials } = useGLTF("/tree.glb");
  return (
    <group {...props} dispose={null}>
      <group rotation={[-Math.PI / 2, 0, 0]}>
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Object_2.geometry}
          material={materials.Wood}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Object_3.geometry}
          material={materials.Wood_light}
        />
      </group>
    </group>
  );
}

useGLTF.preload("/tree.glb");
